
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import { ITranscriptionHistory } from '../../types';
import * as Diff from 'diff';

@Component
export default class DiffDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  @Prop(Object)
  current: ITranscriptionHistory;
  @Prop(Object)
  previous: ITranscriptionHistory;
  html = '';

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  @Watch('show')
  computeDiff() {
    this.html = '';
    //console.log(this.current.uid, this.previous.uid);
    const currentText = this.current.text;
    const previousText = this.previous.text;
    const diff = Diff.diffChars(previousText, currentText);
    diff.forEach((part) => {
      if (part.added) {
        this.html += `<span class='added' style='background: greenyellow;'>${part.value}</span>`;
      } else if (part.removed) {
        this.html += `<span class='removed' style='background: pink;'>${part.value}</span>`;
      } else {
        this.html += part.value;
      }
    });
    this.html = this.html.replace(/\n/g, '<br/>');
    //console.log(this.current.text);
  }

  mounted() {
    //   this.computeDiff();
  }
}
